// https://html.spec.whatwg.org/multipage/input.html#email-state-(type=email)
export const emailRegex = new RegExp(
  /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
)

export const ERROR_NO_ACCESS =
  'Access Denied. Please contact the owner of the system you are attempting to access for details.'
export const ERROR_INVALID_REDIRECT_URL =
  'Redirect URI is not valid. Please contact the asset or solution owner for further information.'
export const ERROR_LOGIN =
  'Internal error, please try logging in again. If you continue to have issues, please review our Help Page and contact Support for assistance.'
